import { call, put, takeLatest } from 'redux-saga/effects';
import { MARKET_CONFIG_CONTENT_API_SUCCESS, MARKET_CONFIG_CONTENT_API_ERROR, GET_MARKET_CONFIG_CONTENT, } from '../constants';
import { appendLocaleInCMSRequest } from '../network';
export function* marketConfigContentCall(data) {
    let result = {};
    const { payload } = data;
    const response = yield call(payload.object.getEntries, appendLocaleInCMSRequest(payload.contentFull));
    if (response && response !== undefined && response !== null) {
        result = { ...result, headerData: response.items[0].fields };
        yield put({
            type: MARKET_CONFIG_CONTENT_API_SUCCESS,
            response: result,
        });
    }
    else {
        yield put({
            type: MARKET_CONFIG_CONTENT_API_ERROR,
        });
    }
}
export default function* marketConfigSaga() {
    yield takeLatest(GET_MARKET_CONFIG_CONTENT, marketConfigContentCall);
}
